import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { ApiService } from '../API/api.service';

@Injectable({
  providedIn: 'root'
})
export class PoService {
 
 constructor( public apiService: ApiService) { }
  private msgSource = new BehaviorSubject({});
  currentEditPurchaseorder = this.msgSource.asObservable();

  private msgSourceRecLot = new BehaviorSubject({});
  currentEditRecLot = this.msgSourceRecLot.asObservable();
  
  private getPOnumber = new BehaviorSubject({});
  currentPoNumber = this.getPOnumber.asObservable();
 
  changeEditPurchaseOrder(data: any) {
    this.msgSource.next(data)
  }
  changeEditRecLot(data: any){
    this.msgSourceRecLot.next(data)
   }
   changePonumber(data: any){
  this.getPOnumber.next(data)
  }




 
  //purchase orders
  getPONumber(body: any): Observable<any>{
    return this.apiService.post('PO/beforePOCreation',body);
  }
  getAllPOs(body: any): Observable<any>{
    return this.apiService.post('PO/getPOsbyAdminId', body);
  }
  getPosByStatusId(body: any): Observable<any>{
    return this.apiService.post('PO/getPOsbyStatusId', body);
  }
  addPO(body: any): Observable<any>{
    return this.apiService.post('PO/createPO',body);
  }
  // S217 P435: the dock scans or types a PO number (own company only).
  findPOByNumber(body: any): Observable<any>{
    return this.apiService.post('PO/findPOByNumber', body);
  }
  getPOdetailsById(body: any): Observable<any>{
    return this.apiService.post('PO/getPOdetailsById',body);
  }
  editPOs(body: any): Observable<any>{
    return this.apiService.post('PO/updatePurchaseOrder',body);
  }
 
  inActivatePO(body: any, param: any): Observable<any>{
    return this.apiService.put('PO/inActivatePO',param, body);
  }
  getReceiveMaterialCode(body: any): Observable<any>{
    return this.apiService.post('rm/beforeRLCreation',body);
  }
  addReceiveMaterial(body: any): Observable<any>{
    return this.apiService.post('rm/createRecieveMaterial',body);
  }
  getAllReceivedLOTs(body: any): Observable<any>{
    return this.apiService.post('rm/getReceivedLots',body);
  }
  editReceivedLOTs(body: any): Observable<any>{
    return this.apiService.post('rm/editReceiveMaterial',body);
  }
  getAllVehicleCondition(): Observable<any>{
    return this.apiService.get('VehilcleCondition/getAllVehilcleCondition');
  }
  statusMoveToComplete(body: any): Observable<any> {
    return this.apiService.post('POMaterials/statusMoveToComplete',body);
  }

  getCompletePO(body : any, param : any): Observable<any> {
    // console.log(body)
    return this.apiService.put('PO/completePO', param , body);
  }
  getPosByAgentManuId(body: any): Observable<any> {
    return this.apiService.post('PO/getPOsByAgentManuId',body);
  }
}
